import {MonkeysGoldParsedGameData} from "../../server/data/MonkeysGoldParsedGameData";
import {MonkeysGoldSymbolUpgradeView} from "./MonkeysGoldSymbolUpgradeView";
import {WinPresentationController} from "@nolimitcity/slot-game/bin/core/winpresentation/WinPresentationController";
import {MonkeysGoldGameModuleConfig} from "../../MonkeysGoldGameModuleConfig";

/**
 * Created by Jerker Nord on 2020-03-31.
 */

export class MonkeysGoldSymbolUpgradeController extends WinPresentationController {

    private _reelsAfterCollapseUpgraded:string[][];
    private _upgradePositionsAfterCollapse:boolean[][];
    private _numberOfUpgrades:number;
    private _previousNumberOfUpgrades:number;
    private _reels:string[][];
    private _view:MonkeysGoldSymbolUpgradeView;

    constructor(indexes:[number, number]) {
        super(indexes, {name : "MonkeysGoldSymbolUpgradeController", skippable : false});
        this._view = MonkeysGoldGameModuleConfig.monkeysGoldSymbolUpgradeView = new MonkeysGoldSymbolUpgradeView();
    }

    protected parseFeatureGameData(data:MonkeysGoldParsedGameData):void {
        this._reelsAfterCollapseUpgraded = data.reelsAfterCollapseUpgraded;
        this._upgradePositionsAfterCollapse = data.upgradePositionsAfterCollapse;
        this._previousNumberOfUpgrades = this._numberOfUpgrades;
        this._numberOfUpgrades = data.numberOfUpgrades;
        this._reels = data.reels;
    }

    protected hasWin():boolean {
        if(this._numberOfUpgrades == 0 && this._previousNumberOfUpgrades > 0) {
            return true;
        }
        return false;
    }

    protected startWinPresentation():void {
        this._view.abort(this._reels);
        this.finish();
    }

    protected stopWinPresentation(isAborted:boolean):void {

    }
}